import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import BasicTooltip from '@wix/da-shared-react/pkg/Popover/BasicTooltip';
import { useFirstTimeFlag } from '@wix/da-shared-react/pkg/redux/firstTimeFlags/hooks';
import { FirstTimeFlag } from '@wix/da-shared-react/pkg/redux/firstTimeFlags/constants';
import s from './DeviantsBarFTUE.scss';

export interface Props {
  className?: string;
}

const DeviantsBarFTUE: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const { dropFlag } = useFirstTimeFlag(FirstTimeFlag.IsNewDywNotSeen);

  useEffect(() => {
    // to avoid getting stuck in an awkward position... just drop the flag when the user scrolls down
    const dropFlagOnScroll = () => {
      // tiny bit of threshold just in case
      if (window.scrollY > 100) {
        dropFlag();
      }
    };
    window.addEventListener('scroll', dropFlagOnScroll, { passive: true });
    return () => window.removeEventListener('scroll', dropFlagOnScroll);
  }, [dropFlag]);

  return (
    <BasicTooltip
      placement="bottom"
      secondaryPlacement="middle"
      withCloseButton
      onClose={dropFlag}
      wrapperClassName={className}
      contentClassName={s['root']}
    >
      <img
        alt=""
        src="https://st.deviantart.net/eclipse/global/svg/dyw2-ftue-tooltip.svg"
        className={s['illustration']}
      />
      <div className={s['title']}>{t('deviantsBar.ftue.tooltip.title')}</div>
      <div className={s['text']}>{t('deviantsBar.ftue.tooltip.text')}</div>
    </BasicTooltip>
  );
};
DeviantsBarFTUE.displayName = 'DeviantsBarFTUE';

export default DeviantsBarFTUE;
